import { defineMessages, useIntl } from 'react-intl'
import Email from '../../../../shared/Email/Email'
import Phone from '../../../../shared/Phone/Phone'
import { Listing } from '../../../../../api/gqlaxy/gql/generated/graphql'
import { Box, Flex, Icon, Text, Heading } from '@homebotapp/hb-react-component-catalog'

export const MSG = defineMessages({
  by: {
    id: 'ListingDetails.ListingAgent.listedBy',
    defaultMessage: 'Listed by:'
  },
  num: {
    id: 'ListingDetails.ListingAgent.license',
    defaultMessage: 'License #{num}'
  }
})

export interface ListingAgentProps {
  listing?: Listing
}

export const ListingAgent = ({ listing }: ListingAgentProps) => {
  const intl = useIntl()

  return (
    <>
      <Heading as='h3' size='3xs' textAlign='left' variant='eyebrow'>
        {intl.formatMessage(MSG.by)}
      </Heading>
      <Flex mt={2} gap={4} align='center'>
        <Icon h={8} w={8} p={2} bg='neutral.200' name='selling' overflow='visible' borderRadius='50%' />
        <Box>
          <Heading as='h4' size='2xs' textAlign='left'>
            {listing?.agent?.name}
          </Heading>
          <Text mb={0} size='xs'>
            {listing?.brokerage?.name}
            {listing?.brokerage?.name && listing?.brokerage?.phone && ' • '}
            {listing?.brokerage?.phone && <Phone value={listing.brokerage.phone} />}
          </Text>
          <Text mb={0} size='xs'>
            {listing?.agent?.stateLicenseNumber &&
              intl.formatMessage(MSG.num, { num: listing.agent.stateLicenseNumber })}
            {listing?.agent?.stateLicenseNumber && listing?.agent?.email && ' • '}
            {listing?.agent?.email}
            {(listing?.agent?.stateLicenseNumber || listing?.agent?.email) && listing?.agent?.phone && ' • '}
            <Phone value={listing?.agent?.phone} />
          </Text>
        </Box>
      </Flex>
    </>
  )
}
